import AutomaticBillingList from '@/components/AutomaticBilling/AutomaticBillingList'

let AutomaticBillingRouter = [{
  path: '/automatic_billing',
  name: 'AutomaticBillingList',
  component: AutomaticBillingList,
  meta: {
    title: 'Facturation automatique',
    requiresAuth: true,
    authorizations: ['internal-billing_index', 'desktop_access']
  }
}]

export default AutomaticBillingRouter



// WEBPACK FOOTER //
// ./src/components/AutomaticBilling/router.js